import React from 'react';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseSwipeableDrawer from '../../../../common/BaseSwipeableDrawer/BaseSwipeableDrawer';
import EditTimesheetFormFullMonth from './component/EditTimesheetFormFullMonth';
import colors from '../../../../../scss/colors';
import classes from './EditMonthlyTimesheetDrawer.module.scss';
import MainButton from '../../../../common/buttons/MainButton';

const StyledSwiper = styled('div')(() => ({
  width: '50px',
  height: '8px',
  backgroundColor: colors.LIGHT_GREY,
  borderRadius: '10px'
}));

const EditMonthlyTimesheetDrawer = ({
  data,
  saveHandler,
  closeHandler,
  allowedWorkTypes,
  rateType,
  deleteLineHandler,
  currentMonth
}) => {
  const { t } = useTranslation();

  const timesheetForm = useFormik({
    initialValues: data?.timesheet
  });

  return (
    <BaseSwipeableDrawer closeHandler={closeHandler}>
      <StyledSwiper />
      <div className={classes.mainContainer}>
        <EditTimesheetFormFullMonth
          isComplexWorktype
          formData={timesheetForm}
          allowedWorkTypes={allowedWorkTypes}
          rateType={rateType}
          choosedMonth={currentMonth}
        />
      </div>
      <div className={classes.actionsContainer}>
        <MainButton
          size="small"
          variant="disabled"
          outlined
          rounded
          action={() => {
            deleteLineHandler(data.timesheet.Id);
            closeHandler();
          }}
          forceWidth="100%"
        >
          {t('common.general.delete')}
        </MainButton>
        <MainButton
          size="small"
          variant={!timesheetForm.dirty ? 'disabled' : 'primary'}
          outlined={false}
          rounded
          disabled={!timesheetForm.dirty}
          action={() => saveHandler(timesheetForm.values)}
          forceWidth="100%"
        >
          {t('common.general.save')}
        </MainButton>
      </div>
    </BaseSwipeableDrawer>
  );
};

export default EditMonthlyTimesheetDrawer;
